import React, { useEffect, useState } from 'react';
import DimmerLoader from './DimmerLoader';

interface IProps {
  loading: boolean;
  delayMs?: number;
}

/**
 * This component will return a loader in the middle of the screen with a backdrop background if loading continues more
 * than delayMs milliseconds. The default delay is 500ms
 */
const DelayedDimmerLoader = ({ loading, delayMs = 500 }: IProps) => {
  const [showDimmer, setShowDimmer] = useState(false);

  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => setShowDimmer(true), delayMs);

      return () => {
        setShowDimmer(false);
        clearTimeout(timeout);
      };
    }
  }, [delayMs, loading]);
  return showDimmer ? <DimmerLoader /> : null;
};

export default DelayedDimmerLoader;
